<template>
    <b-tabs pills card vertical class="">
        <b-tab title-link-class="" :key="idx"  :active="provider.is_active"  v-for="(provider,idx) in providers">
            <template slot="title">
                <div class="fs-lg px-4 text-center ">
                    {{provider.name }}
                </div>
            </template>
            <b-card-text>
                <component v-bind:rest="rest" v-bind:is="provider.type" :provider="provider"></component>
            </b-card-text>
        </b-tab>
    </b-tabs>
</template>

<script>
import turbo_sms from "./sms_provider/turbo_sms.vue";
export default {
    name: "restaurant_sms",
    components : {
        turbo_sms
    },
    props : {
        rest : {
            type : Object
        }
    },
    data() {
        return {
            is_load: true,
            providers :  [
                {
                    'name' : this.__t('TURBO_SMS'),
                    'is_active' : false,
                    'type' : "turbo_sms",
                },
             ]
        }
    },
    created() {

    },
}
</script>

<style scoped>

</style>
